/* Cart redesign behaviors — no AJAX cart calls; the native form POST to /cart
   stays the single source of truth (disable_ajax_cart is on for this store).
   Legacy contracts honored: #agree / .terms-conditions (bc.script.js gate),
   button[name=checkout] inside .cart-action (Route app embed entrypoint). */
(function () {
  'use strict';

  var form = document.getElementById('cart-redesign-form');
  if (!form) return;

  var MAX_QTY = 9;

  /* ----- route-disabled: Route embed is off, so nothing else can remove a
     Route line left in a pre-switch cart. Drop it and reload once. ----- */
  var routeKeys = form.querySelectorAll('[data-cartrd-route-key]');
  if (routeKeys.length) {
    var routeTried = false;
    try { routeTried = sessionStorage.getItem('cartrd-route-purged') === '1'; } catch (err) { }
    if (!routeTried) {
      try { sessionStorage.setItem('cartrd-route-purged', '1'); } catch (err) { }
      var routeUpdates = {};
      for (var r = 0; r < routeKeys.length; r++) routeUpdates[routeKeys[r].getAttribute('data-cartrd-route-key')] = 0;
      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: routeUpdates })
      }).then(function (res) {
        if (res.ok) window.location.reload();
      }).catch(function () { });
    }
  } else {
    try { sessionStorage.removeItem('cartrd-route-purged'); } catch (err) { }
  }

  /* ----- Quantity stepper + "quantities changed" nudge ----- */
  function refreshDirty() {
    var inputs = form.querySelectorAll('input.cartrd-qty-input');
    var dirty = false;
    for (var i = 0; i < inputs.length; i++) {
      if (inputs[i].value !== inputs[i].defaultValue) { dirty = true; break; }
    }
    form.classList.toggle('is-dirty', dirty);
  }

  form.addEventListener('click', function (e) {
    var btn = e.target.closest('.cartrd-step');
    if (!btn) return;
    var input = btn.parentElement.querySelector('input.cartrd-qty-input');
    if (!input) return;
    var val = parseInt(input.value, 10);
    if (isNaN(val)) val = parseInt(input.defaultValue, 10) || 0;
    val += parseInt(btn.getAttribute('data-dir'), 10);
    var min = parseInt(input.min, 10) || 0;
    var max = parseInt(input.max, 10) || MAX_QTY;
    input.value = Math.min(max, Math.max(min, val));
    refreshDirty();
  });

  form.addEventListener('input', function (e) {
    if (e.target.classList && e.target.classList.contains('cartrd-qty-input')) refreshDirty();
  });

  /* ----- Options expander ----- */
  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('.cartrd-options-toggle');
    if (!toggle) return;
    var wrap = toggle.closest('[data-cartrd-options]');
    if (!wrap) return;
    var open = wrap.hasAttribute('data-expanded');
    if (open) {
      wrap.removeAttribute('data-expanded');
    } else {
      wrap.setAttribute('data-expanded', '');
    }
    toggle.setAttribute('aria-expanded', String(!open));
    var label = toggle.querySelector('[data-cartrd-morelabel]');
    if (label) label.textContent = open ? toggle.getAttribute('data-more') : toggle.getAttribute('data-less');
  });

  /* ----- Mobile unit price under the title: mirrored from the "each" money
     span (which carries the Bold rewrite anchor — never duplicate that). ----- */
  var syncMobilePrices = function () {
    var items = form.querySelectorAll('.cartrd-item');
    for (var i = 0; i < items.length; i++) {
      var src = items[i].querySelector('.cartrd-each > span[data-key]');
      var dst = items[i].querySelector('[data-cartrd-mprice]');
      if (src && dst && dst.textContent !== src.textContent) dst.textContent = src.textContent;
    }
  };
  syncMobilePrices();
  new MutationObserver(syncMobilePrices).observe(form, { childList: true, subtree: true, characterData: true });

  /* ----- Terms gate: disabled-CTA model (replaces the legacy alert UX).
     #agree defaults checked; unchecking disables the checkout button and any
     Route-cloned button. bc.script.js's alert handler stays bound to the
     original button but can only fire while it is enabled (terms checked),
     so its alert path is unreachable and its $0-cart guard still works. ----- */
  var agree = document.getElementById('agree');
  var flashTerms = function () {
    var terms = form.querySelector('.terms-conditions');
    if (!terms) return;
    terms.scrollIntoView({ behavior: 'smooth', block: 'center' });
    terms.classList.add('cartrd-terms-flash');
    setTimeout(function () { terms.classList.remove('cartrd-terms-flash'); }, 1600);
  };
  if (agree) {
    var syncTerms = function () {
      var ok = agree.checked;
      var buttons = form.querySelectorAll('button[name="checkout"], [data-route-cloned-button] button, button[data-route-cloned-button]');
      for (var i = 0; i < buttons.length; i++) {
        buttons[i].disabled = !ok;
        buttons[i].setAttribute('aria-disabled', String(!ok));
      }
      /* Route's "Continue without package protection" runs its own JS and
         navigates itself — lock it too so NOTHING proceeds unchecked */
      var cwc = form.querySelectorAll('.route-continue-without-coverage-link');
      for (var j = 0; j < cwc.length; j++) {
        cwc[j].classList.toggle('cartrd-cta-locked', !ok);
        cwc[j].setAttribute('aria-disabled', String(!ok));
        if ('disabled' in cwc[j]) cwc[j].disabled = !ok;
      }
    };
    agree.addEventListener('change', syncTerms);
    syncTerms();

    /* Route mounts its widget/cloned button after page load — keep the clone
       in sync with the terms state as soon as it appears. */
    var ctaZone = form.querySelector('.cartrd-cta-zone') || form;
    new MutationObserver(syncTerms).observe(ctaZone, { childList: true, subtree: true });

    /* Belt and braces: block any checkout-ish submission while unchecked. */
    form.addEventListener('submit', function (e) {
      var s = e.submitter;
      var isCheckout = s && (s.name === 'checkout' || s.closest('[data-route-cloned-button]'));
      if (isCheckout && !agree.checked) {
        e.preventDefault();
        flashTerms();
      }
    });
    /* Capture-phase click guard: fires at the document before Route's own
       element handlers, so the cloned button AND the continue-without link
       are dead while terms are unchecked, whatever JS they carry. */
    document.addEventListener('click', function (e) {
      if (agree.checked) return;
      var target = e.target.closest('.route-continue-without-coverage-link, [data-route-cloned-button], button[name="checkout"]');
      if (!target || !form.contains(target)) return;
      e.preventDefault();
      e.stopImmediatePropagation();
      flashTerms();
    }, true);
  }

  /* ----- Discount apply: AJAX, no page refresh. GET /discount/CODE attaches
     the code to the cart session; cart.js then tells us whether it was
     applicable. Success patches the rail in place (chip, note, discount row,
     Est. Total); failure shows the design's inline red error. Capture-phase
     so the HulkApps handler on the same button (cross-domain redirect, no
     in-cart state) never fires. ----- */
  var xhrJson = function (method, url, body, cb) {
    var x = new XMLHttpRequest();
    x.open(method, url);
    if (body) x.setRequestHeader('Content-Type', 'application/json');
    x.onload = function () {
      var data = null;
      try { data = JSON.parse(x.responseText); } catch (err) { }
      cb(x.status, data);
    };
    x.onerror = function () { cb(0, null); };
    x.send(body ? JSON.stringify(body) : null);
  };
  var money = function (cents) {
    return '$' + (cents / 100).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };
  var setPromoError = function (msg) {
    var el = form.querySelector('.cartrd-promo-error');
    if (!el) return;
    el.textContent = msg || '';
    el.style.display = msg ? 'block' : 'none';
  };
  var parseMoneyCents = function (text) {
    var n = parseFloat(String(text).replace(/[^0-9.]/g, ''));
    return isNaN(n) ? null : Math.round(n * 100);
  };
  var estShipCents = (function () {
    var el = form.querySelector('[data-cartrd-ship-cents]');
    return el ? (parseInt(el.getAttribute('data-cartrd-ship-cents'), 10) || 0) : 0;
  })();
  /* Visible Est. Total = goods total (Bold-anchored hidden source, which
     Bold's options.js rewrites) + the weight-based shipping estimate */
  var refreshEstTotal = function () {
    var goods = form.querySelector('[data-cartrd-goods]');
    var est = form.querySelector('[data-cartrd-est]');
    if (!goods || !est) return;
    var cents = parseMoneyCents(goods.textContent);
    if (cents === null) return;
    var text = money(cents + estShipCents);
    if (est.textContent.trim() !== text) est.textContent = text;
    var targets = form.querySelectorAll('[data-cartrd-total-mirror]');
    for (var i = 0; i < targets.length; i++) {
      if (targets[i].textContent !== text) targets[i].textContent = text;
    }
    if (typeof updateMobileCta === 'function') updateMobileCta();
  };
  var setGoodsTotal = function (cents) {
    /* replace everything after the Bold anchor (Bold may have wrapped its
       rewritten money in a span) */
    var goods = form.querySelector('[data-cartrd-goods]');
    if (!goods) {
      /* stale cached markup without the goods-source span: write the
         shipping-inclusive total straight into the visible element */
      var est = form.querySelector('[data-cartrd-est]');
      if (!est) return;
      var a = est.querySelector('.bold_cart_total');
      if (a) { while (a.nextSibling) est.removeChild(a.nextSibling); est.appendChild(document.createTextNode(money(cents + estShipCents))); }
      else est.textContent = money(cents + estShipCents);
      var targets = form.querySelectorAll('[data-cartrd-total-mirror]');
      for (var i = 0; i < targets.length; i++) targets[i].textContent = money(cents + estShipCents);
      if (typeof updateMobileCta === 'function') updateMobileCta();
      return;
    }
    var boldAnchor = goods.querySelector('.bold_cart_total');
    if (boldAnchor) {
      while (boldAnchor.nextSibling) goods.removeChild(boldAnchor.nextSibling);
    } else {
      goods.textContent = '';
    }
    goods.appendChild(document.createTextNode(money(cents)));
    refreshEstTotal();
  };
  var renderApplied = function (code, cart) {
    var railCardEl = form.querySelector('.cartrd-rail-card');
    var anchorEl = railCardEl.querySelector('.cartrd-rail-nudge');
    var old = railCardEl.querySelectorAll('.cartrd-code-row, .cartrd-discount-chip, .cartrd-discount');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    var row = document.createElement('div');
    row.className = 'cartrd-code-row';
    row.innerHTML = '<span class="cartrd-code-chip"></span>';
    var chip = row.firstChild;
    chip.appendChild(document.createTextNode(code + ' '));
    var rm = document.createElement('button');
    rm.type = 'button'; rm.className = 'cartrd-code-remove'; rm.setAttribute('aria-label', 'Remove code'); rm.setAttribute('data-cartrd-remove-code', ''); rm.textContent = '✕';
    chip.appendChild(rm);
    var note = document.createElement('p');
    note.className = 'cartrd-discount-chip';
    note.textContent = "Coupon '" + code + "' applied — you saved " + money(cart.total_discount) + '!';
    railCardEl.insertBefore(row, anchorEl);
    railCardEl.insertBefore(note, anchorEl);
    var sub = form.querySelector('.cartrd-subtotal');
    var disc = document.createElement('div');
    disc.className = 'cartrd-row cartrd-discount';
    disc.setAttribute('data-cartrd-discount', '');
    disc.innerHTML = '<span></span><span class="cartrd-discount-amount"></span>';
    disc.firstChild.textContent = 'Discount (' + code + ')';
    disc.lastChild.textContent = '−' + money(cart.total_discount);
    sub.parentNode.insertBefore(disc, sub.nextSibling);
    setGoodsTotal(cart.total_price);
  };
  var renderRemoved = function (cart) {
    var railCardEl = form.querySelector('.cartrd-rail-card');
    var old = railCardEl.querySelectorAll('.cartrd-code-row, .cartrd-discount-chip, .cartrd-discount');
    for (var i = 0; i < old.length; i++) old[i].parentNode.removeChild(old[i]);
    setGoodsTotal(cart.total_price);
  };
  var clearAppCouponCaches = function () {
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
    document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=.' + window.location.hostname.split('.').slice(-2).join('.');
    try {
      localStorage.removeItem('docapp-coupon');
      localStorage.removeItem('docapp-total-discount');
      sessionStorage.removeItem('docapp-shipping-discounts');
    } catch (err) { /* storage unavailable */ }
  };
  /* HulkApps keeps the code in MEMORY and its poller can re-apply it even
     without a page load. After a removal, watch the cart a few times and
     re-clear if it reappears; if the app keeps winning, fall back to a
     reload with the crd_rm marker (the load-time path is proven). A fresh
     user apply cancels enforcement. */
  var removalTimer = null;
  var cancelRemovalWatch = function () { if (removalTimer) { clearTimeout(removalTimer); removalTimer = null; } };
  var watchRemoval = function (attempt) {
    cancelRemovalWatch();
    if (attempt > 3) {
      var u = new URL(window.location.href);
      u.searchParams.set('crd_rm', '1');
      u.searchParams.set('cb', Date.now());
      window.location.replace(u.toString());
      return;
    }
    removalTimer = setTimeout(function () {
      if (form.querySelector('.cartrd-code-chip') || applyBusy) return; // user re-applied
      xhrJson('GET', '/cart.js?' + Date.now(), null, function (status, cart) {
        if (!cart) { watchRemoval(attempt + 1); return; }
        if ((cart.discount_codes || []).length || cart.total_discount > 0) {
          clearAppCouponCaches();
          xhrJson('POST', '/cart/update.js', { discount: '' }, function (s2, c2) {
            if (s2 === 200 && c2) renderRemoved(c2);
            watchRemoval(attempt + 1);
          });
        }
      });
    }, attempt === 1 ? 1200 : 2500);
  };
  var applyBusy = false;
  var applyBusySince = 0;
  /* the HulkApps widget replaces our fallback box on some loads — read the
     code from whichever coupon input is actually visible */
  var getCouponInput = function () {
    var cands = form.querySelectorAll('input.hulkapps_discount_code, .docapp-coupon-input input');
    for (var i = 0; i < cands.length; i++) {
      if (cands[i].type !== 'hidden' && cands[i].offsetWidth > 0) return cands[i];
    }
    return form.querySelector('input.hulkapps_discount_code');
  };
  var attachCode = function (code, cb) {
    xhrJson('GET', '/discount/' + encodeURIComponent(code), null, function () {
      xhrJson('GET', '/cart.js?' + Date.now(), null, function (status, cart) {
        var entry = cart && (cart.discount_codes || []).filter(function (d) {
          return d.code.toLowerCase() === code.toLowerCase();
        })[0];
        cb(entry, cart);
      });
    });
  };
  var applyDiscount = function (clickedBtn) {
    if (applyBusy && Date.now() - applyBusySince < 15000) return;
    var input = getCouponInput();
    var code = input && input.value.trim();
    if (!code) { if (input) input.focus(); return; }
    applyBusy = true;
    applyBusySince = Date.now();
    cancelRemovalWatch();
    setPromoError('');
    var applyBtn = (clickedBtn && clickedBtn.tagName) ? clickedBtn : form.querySelector('.hulkapps_discount_button');
    var spinStart = 0;
    var setSpin = function (on) {
      if (!applyBtn) return;
      if (on) {
        spinStart = Date.now();
        applyBtn.classList.add('cartrd-busy');
        applyBtn.disabled = true;
      } else {
        /* keep the spinner visible ≥450ms so fast responses don't blink */
        setTimeout(function () {
          applyBtn.classList.remove('cartrd-busy');
          applyBtn.disabled = false;
        }, Math.max(0, 450 - (Date.now() - spinStart)));
      }
    };
    setSpin(true);
    var finishSuccess = function (entry, cart) {
      input.value = '';
      try { sessionStorage.removeItem('cartrd-removed'); } catch (err) { }
      renderApplied(entry.code, cart);
      setSpin(false);
      applyBusy = false;
    };
    var finishFail = function () {
      document.cookie = 'discount_code=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      setPromoError("Code '" + code + "' is not valid or doesn't apply to this cart.");
      setSpin(false);
      applyBusy = false;
    };
    xhrJson('GET', '/cart.js?' + Date.now(), null, function (s0, cart0) {
      var prev = cart0 && (cart0.discount_codes || []).filter(function (d) { return d.applicable; })[0];
      var prevCode = prev && prev.code;
      attachCode(code, function (entry, cart) {
        if (entry && entry.applicable && cart.total_discount > 0) { finishSuccess(entry, cart); return; }
        if (entry && !entry.applicable && prevCode && prevCode.toLowerCase() !== code.toLowerCase()) {
          /* Shopify STACKS the pending code next to the applied one, and the
             new code reads applicable:false when the two can't combine —
             replace-semantics: clear, re-attach the new code alone */
          xhrJson('POST', '/cart/update.js', { discount: '' }, function () {
            attachCode(code, function (entry2, cart2) {
              if (entry2 && entry2.applicable && cart2.total_discount > 0) { finishSuccess(entry2, cart2); return; }
              /* genuinely inapplicable on its own — strip it, restore the
                 previous code, and report the failure */
              xhrJson('POST', '/cart/update.js', { discount: '' }, function () {
                attachCode(prevCode, function (entryP, cartP) {
                  if (entryP && entryP.applicable && cartP.total_discount > 0) renderApplied(entryP.code, cartP);
                  finishFail();
                });
              });
            });
          });
          return;
        }
        /* no prior code (or same code): strip the inapplicable pending code */
        if (entry) xhrJson('POST', '/cart/update.js', { discount: '' }, function () { });
        finishFail();
      });
    });
  };
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('.hulkapps_discount_button, .docapp-coupon-input button, .docapp-coupon-input a, .docapp-coupon-input [class*="apply"], .docapp-coupon-input [class*="btn"]');
    if (!btn || !form.contains(btn)) return;
    if (btn.tagName === 'INPUT' || btn.tagName === 'TEXTAREA') return;
    e.preventDefault();
    e.stopImmediatePropagation();
    applyDiscount(btn);
  }, true);
  /* Remove an applied code in place — no page reload. /cart/update.js with
     discount:"" clears the cart's codes (verified) and returns the updated
     cart JSON, which patches the rail. The discount_code cookie and
     HulkApps' instant-load localStorage cache are cleared too, or the next
     PAGE LOAD would re-apply the code (no reload here also means the app
     gets no load event to re-apply on now). XHR, not fetch — the HulkApps
     embed wraps window.fetch here. */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cartrd-remove-code]');
    if (!btn || !form.contains(btn)) return;
    btn.disabled = true;
    clearAppCouponCaches();
    /* persistent policy: keep the voucher removed on every future load of
       this session until the user applies a code again */
    try { sessionStorage.setItem('cartrd-removed', '1'); } catch (err) { }
    xhrJson('POST', '/cart/update.js', { discount: '' }, function (status, cart) {
      if (status === 200 && cart) {
        renderRemoved(cart);
        watchRemoval(1);
      } else {
        btn.disabled = false;
      }
    });
  });

  /* Every page load while the removal policy is active: clear the app's
     coupon caches immediately (before its instant-load re-applies) and
     sweep the cart shortly after in case it re-applied anyway. Survives
     stale cached pages — whichever load runs this JS enforces it. */
  var removalPolicy = false;
  try { removalPolicy = sessionStorage.getItem('cartrd-removed') === '1'; } catch (err) { }
  if (removalPolicy) {
    clearAppCouponCaches();
    var sweep = function (round) {
      if (round > 3) return;
      setTimeout(function () {
        var active = false;
        try { active = sessionStorage.getItem('cartrd-removed') === '1'; } catch (err) { }
        if (!active || applyBusy || form.querySelector('.cartrd-promo-error')) return;
        xhrJson('GET', '/cart.js?' + Date.now(), null, function (status, cart) {
          if (!cart) { sweep(round + 1); return; }
          if ((cart.discount_codes || []).length || cart.total_discount > 0) {
            clearAppCouponCaches();
            xhrJson('POST', '/cart/update.js', { discount: '' }, function (s2, c2) {
              if (s2 === 200 && c2) renderRemoved(c2);
              sweep(round + 1);
            });
          }
        });
      }, round === 1 ? 1200 : 2500);
    };
    sweep(1);
  }

  /* Landing after a removal (possibly on the other domain): clear THIS
     origin's HulkApps cache, and if its script already re-applied the code,
     clear the cart once more and land clean (param stripped — loop-safe). */
  if (new URLSearchParams(window.location.search).has('crd_rm')) {
    try {
      localStorage.removeItem('docapp-coupon');
      localStorage.removeItem('docapp-total-discount');
      sessionStorage.removeItem('docapp-shipping-discounts');
    } catch (err) { /* storage unavailable */ }
    setTimeout(function () {
      var probe = new XMLHttpRequest();
      probe.open('GET', '/cart.js?' + Date.now());
      probe.onload = function () {
        var clean = new URL(window.location.href);
        clean.searchParams.delete('crd_rm');
        clean.searchParams.set('cb', Date.now());
        var codes = [];
        try { codes = JSON.parse(probe.responseText).discount_codes || []; } catch (err) { }
        if (codes.length) {
          var x2 = new XMLHttpRequest();
          x2.open('POST', '/cart/update.js');
          x2.setRequestHeader('Content-Type', 'application/json');
          x2.onload = function () { window.location.replace(clean.toString()); };
          x2.onerror = function () { window.location.replace(clean.toString()); };
          x2.send(JSON.stringify({ discount: '' }));
        } else if (form.querySelector('.cartrd-code-chip')) {
          window.location.replace(clean.toString());
        } else {
          history.replaceState(null, '', clean.toString());
        }
      };
      probe.send();
    }, 1800);
  }
  form.addEventListener('keydown', function (e) {
    if (e.key !== 'Enter' || !e.target.closest) return;
    if (e.target.closest('.discount_code_box, .docapp-coupon-input') && e.target.tagName === 'INPUT') {
      e.preventDefault();
      e.stopPropagation();
      applyDiscount();
    }
  }, true);

  /* ----- HulkApps discount widget dedupe: when the app injects its own
     coupon UI (.docapp-widget), flag the rail so CSS hides the theme's
     fallback discount box (see cart-redesign.css). ----- */
  var railCard = form.querySelector('.cartrd-rail-card');
  if (railCard) {
    var syncCoupon = function () {
      if (railCard.querySelector('.docapp-widget')) railCard.classList.add('cartrd-has-app-coupon');
    };
    new MutationObserver(syncCoupon).observe(railCard, { childList: true, subtree: true });
    syncCoupon();
  }

  /* ----- Package Protection card: revealed once Route's widget mounts;
     fee mirrored from Route's cloned-button premium label. ----- */
  var protCard = form.querySelector('.cartrd-prot-card');
  if (protCard) {
    var syncProt = function () {
      var prem = form.querySelector('.route-premium-text-stacked');
      if (!prem) return;
      protCard.classList.add('is-live');
      var m = prem.textContent.match(/\$[\d,]+(?:\.\d\d)?/);
      var feeEl = protCard.querySelector('[data-cartrd-prot-fee]');
      if (m && feeEl && feeEl.textContent !== m[0]) feeEl.textContent = m[0];
    };
    new MutationObserver(syncProt).observe(form.querySelector('.cartrd-cta-zone') || form, { childList: true, subtree: true, characterData: true });
    syncProt();
  }

  /* ----- Mobile bar: real-height page padding (no giant blank) and the
     design's total-in-button CTA label ("CHECKOUT — $X"). The Est. Total
     strong carries the Bold rewrite anchor — it is the single source of
     truth for the total; Route's cloned-button label (or our own button
     when Route is absent) is rewritten from it on mobile only. ----- */
  var mqMobile = window.matchMedia('(max-width: 767px)');
  var sectionEl = document.querySelector('.cartrd');
  var padForBar = function () {
    if (!sectionEl) return;
    var zone = form.querySelector('.cartrd-cta-zone');
    if (mqMobile.matches && zone) {
      sectionEl.style.paddingBottom = Math.ceil(zone.getBoundingClientRect().height + 16) + 'px';
    } else {
      sectionEl.style.paddingBottom = '';
    }
  };
  var updateMobileCta = function () {
    var est = form.querySelector('[data-cartrd-est]');
    var total = est ? est.textContent.trim() : '';
    var cloneLabel = form.querySelector('[data-route-cloned-button] .route-checkout-text-stacked');
    var own = form.querySelector('button.cartrd-checkout');
    if (mqMobile.matches && total) {
      if (cloneLabel) {
        if (!cloneLabel.hasAttribute('data-cartrd-orig')) cloneLabel.setAttribute('data-cartrd-orig', cloneLabel.textContent);
        var want = 'Checkout — ' + total;
        if (cloneLabel.textContent !== want) cloneLabel.textContent = want;
      } else if (own) {
        if (!own.hasAttribute('data-cartrd-orig')) own.setAttribute('data-cartrd-orig', own.textContent);
        var want2 = 'Checkout — ' + total;
        if (own.textContent !== want2) own.textContent = want2;
      }
    } else {
      var els = [cloneLabel, own];
      for (var i = 0; i < els.length; i++) {
        if (els[i] && els[i].hasAttribute('data-cartrd-orig') && els[i].textContent !== els[i].getAttribute('data-cartrd-orig')) {
          els[i].textContent = els[i].getAttribute('data-cartrd-orig');
        }
      }
    }
  };
  var onMobileLayout = function () { padForBar(); updateMobileCta(); };
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', onMobileLayout);
  window.addEventListener('resize', padForBar);
  var mobileZone = form.querySelector('.cartrd-cta-zone');
  if (mobileZone) new MutationObserver(onMobileLayout).observe(mobileZone, { childList: true, subtree: true });
  onMobileLayout();

  /* Bold rewrites the hidden goods source — recompose the visible total */
  var goodsSource = form.querySelector('[data-cartrd-goods]');
  if (goodsSource) {
    new MutationObserver(refreshEstTotal).observe(goodsSource, { childList: true, subtree: true, characterData: true });
    refreshEstTotal();
  }
})();
